import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, DataTable, FlexBox, Icon, IconButton, Page, Text, Timestamp, Tooltip, } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppLink } from 'components/appLink';
import { getEventLog, getSubscription } from 'components/settings/api/webhooks';
import { parseEventPayload } from '../../webhooks.utils';
import { DeliveryStatus } from '../deliveryStatus';
import { PayloadModal } from '../payloadModal';
export function EventLog() {
    const [logs, setLogs] = useState([]);
    const [payload, setPayload] = useState(null);
    const [subscriptionName, setSusbcriptionName] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const { id, event } = useParams();
    useEffect(() => {
        getAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getAll = useCallback(() => {
        if (id && event) {
            setIsLoading(true);
            setIsError(false);
            getEventLog({ id, event })
                .then(({ data }) => {
                setLogs(data.events);
                setIsLoading(false);
            })
                .catch(() => {
                setIsLoading(false);
                setIsError(true);
            });
            getSubscription(id).then(({ data }) => setSusbcriptionName(data.name));
        }
    }, [id, event]);
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ titleMeta: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [!id && (_jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: subscriptionName }))), id && (_jsx(AppLink, Object.assign({ path: "/settings/integrations/webhooks/:id", params: { path: { id } } }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: subscriptionName })) }))), _jsx(Icon, { name: "angle-right" }), _jsx(Text.Heading, Object.assign({ variant: "heading-3" }, { children: event })), (logs === null || logs === void 0 ? void 0 : logs.length) > 0 && (_jsx(Badge, Object.assign({ size: "small", variant: "secondary" }, { children: logs.length }))), _jsx(Tooltip, Object.assign({ content: "Help and documentation.", dark: true }, { children: _jsx(IconButton, { icon: "question", variant: "tertiary", onClick: () => window.open('https://docs.dixa.io/docs/webhooks-guide', '_blank', 'noopener,noreferrer') }) }))] })) }, { children: _jsx(DataTable, { data: logs, tableStyleProps: {
                        stickyHeader: true,
                    }, tableStatusProps: {
                        loading: isLoading,
                        loadingFailed: isError,
                        onLoadingRetry: () => getAll(),
                        emptyState: !logs.length && !isError
                            ? {
                                title: 'Nothing to show here',
                                description: 'No events found',
                            }
                            : undefined,
                    }, columns: [
                        {
                            label: 'Event Id',
                            selector: ({ payload }) => {
                                const parsedPayload = parseEventPayload(payload);
                                return (parsedPayload === null || parsedPayload === void 0 ? void 0 : parsedPayload.event_id) || '';
                            },
                        },
                        {
                            label: 'Status',
                            selector: ({ delivery_status: { response_code, response_text, is_success }, }) => (_jsx(DeliveryStatus, { code: response_code, text: response_text, isSuccess: is_success }, "status")),
                        },
                        {
                            label: 'Timestamp',
                            selector: ({ delivery_status: { delivery_timestamp } }) => (_jsx(Timestamp, { time: delivery_timestamp }, "timestamp")),
                        },
                        {
                            label: undefined,
                            style: {
                                width: 0,
                            },
                            selector: ({ payload }) => (_jsx(Tooltip, Object.assign({ content: "View payload", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "code", onClick: () => {
                                        const parsedPayload = parseEventPayload(payload);
                                        if (parsedPayload) {
                                            setPayload(parsedPayload);
                                        }
                                    } }) }))),
                        },
                    ] }) })), payload && (_jsx(PayloadModal, { isOpen: !!payload, payload: payload, onClose: () => {
                    setPayload(null);
                } }))] }));
}
